<div class="container" #listContainer>
    <div
        class="dropdown"
        data-cy="mimics-toolbar-parent-tool"
        [class.show]="dropdownOpen"
        [class.select]="selectedStatus">
        <div class="text-container">
            <mat-icon class="text-icon" [svgIcon]="icon"></mat-icon>
            <p class="text">
                {{ title | translate }}
            </p>
        </div>
        <mat-icon class="dropdown-icon" [class.show]="dropdownOpen" svgIcon="arrow-down"></mat-icon>
    </div>
    <ul class="items-list" [class.show]="dropdownOpen">
        <li
            class="item"
            data-cy="mimics-toolbar-child-tool"
            [class.select]="selectedItem?.name === item.name"
            *ngFor="let item of items; index as i"
            (click)="itemClick($event, i); $event.preventDefault()">
            <mat-icon [svgIcon]="item.svgIcon" *ngIf="item?.svgIcon"></mat-icon>
            <span>{{ translatePrefix.concat('.', item.name) | translate }}</span>
        </li>
    </ul>
</div>

<input
    #imagefile
    type="file"
    style="display: none"
    (change)="onSetImage($event)"
    accept="image/apng, image/jpeg, image/png" />

<input #svgFile type="file" style="display: none" (change)="onSetSvg($event)" accept=".svg" />
